import * as React from 'react';
import Page from '../common/Page';
import { BaseProps } from '../../types';
import Plans from './Plans';

const SignUp: React.FunctionComponent<BaseProps> = () => {
    return (
        <Page>
            <Plans
                pageTitle={'Sign Up'} 
                actionTitle={'Select This Package'}
                proAction={'/signup/register?plan=portfolio_designer'}
                eliteAction={'/signup/register?plan=advisor_workstation'}
            />
        </Page>
    )
}
export default SignUp